<script setup>
import Layout from "../../Components/Shared/LayoutAdmin.vue";
import FruitForm from "../../Components/Forms/FruitForm.vue";
import FruitCollectionPaginated from "../../Components/Fruit/FruitCollectionPaginated.vue";
import ModalComponent from "../../Components/Shared/ModalComponent.vue";
import CategoryForm from "../../Components/Forms/CategoryForm.vue";
import ClassificationForm from "../../Components/Forms/ClassificationForm.vue";
import UserForm from "../../Components/Forms/UserForm.vue";
import SearchComponent from "../../Components/Shared/SearchComponent.vue";
import TableItem from "../../Components/Shared/TableItem.vue";
import CurrencySwitcher from '../../Components/Shared/CurrencySwitcher.vue'
import UploadClassificationsExcel from "../../Components/Forms/UploadClassificationsExcel.vue";
import { Link } from '@inertiajs/inertia-vue3'
import HeaderAdminComponent from "../../Components/Shared/HeaderAdminComponent.vue";

import { ref } from "vue";
import useApi from "../../Services/useApi";
import { Inertia } from "@inertiajs/inertia";
import useNotification from "../../Services/useNotification";

const props = defineProps(["categories", "fruits", "last_fruits", "users", "classifications"]);
const collections_active = ref("frutas");
const modalTitle = ref("Crear");
const api = useApi();
const notificate = useNotification()
// fruit
const fruitModal = ref(false);
const initFruit = {
    name: "",
    description: "",
    scientific_name: "",
    origin: "",
    seasonality: "",
    uses: "",
    nutritional_information: "",
    information_sources: "",
    price: "",
    supply: "",
    marketcap: "",
    unit: "",
    featured: 0,
    image: "",
};
const fruitToCreate = ref(initFruit);
const createFruit = () => {
    fruitToCreate.value = initFruit;
    fruitModal.value = true;
    modalTitle.value = "Crear";
};
//category
const categoryModal = ref(false);
const initCategory = {
    name: "",
};
const categoryToCreate = ref(initCategory);
const createCategory = () => {
    categoryToCreate.value = initCategory;
    categoryModal.value = true;
    modalTitle.value = "Crear";
};
const changeTab = (tab) => {
    collections_active.value = tab;
};
// users 
const initUser = {
    name: "",
    email: "",
    password: "",
    role_id: "",
};
const userToCreate = ref(initUser);
const userModal = ref(false)
//clasiffications
const classificationModal = ref(false);
const initClassification = {
    name: "",
    description: "",
    parent_id: null,
    principal: true,
    type: "VITA"
};
const classificationToCreate = ref(initClassification);
const createClassification = () => {
    classificationToCreate.value = initClassification;
    classificationModal.value = true;
    modalTitle.value = "Crear";
};
const resetModals = () => {
    fruitModal.value = false;
    categoryModal.value = false;
    userModal.value = false;
    classificationModal.value = false;
};
</script>

<template>
    <Layout>
        <HeaderAdminComponent title="Dashboard"></HeaderAdminComponent>
        <div class="container relative z-10 p-4 mx-auto md:pt-20 px-10">
            <div class="max-w-xl mx-auto my-10 ">
                <SearchComponent />     
            </div>
            <div class="grid grid-cols-2 gap-4 my-4 md:grid-cols-4">
                <div
                    class="p-4 text-center border-2 cursor-pointer rounded-2xl border-light_green bg-light_yellow hover:bg-yellow "
                    @click="createFruit"
                >
                    <span class="material-symbols-outlined admin-icon text-light_gray">
                        add_circle
                    </span>
                    <h3 class="text-enriqueto_green">Crear nueva fruta</h3>
                </div>
                <div
                    class="p-4 text-center border-2 cursor-pointer rounded-2xl border-light_green bg-light_yellow hover:bg-yellow"
                    @click="createCategory"
                >
                    <span class="material-symbols-outlined admin-icon text-light_gray">
                    playlist_add
                    </span>
                    <h3 class="text-enriqueto_green">Crear nueva categoria</h3>
                </div>
                <div
                    class="p-4 text-center border-2 cursor-pointer rounded-2xl border-light_green bg-light_yellow hover:bg-yellow"
                    @click="userModal = true"
                >
                    <span class="material-symbols-outlined admin-icon text-light_gray">
                    person
                    </span>
                    <h3 class="text-enriqueto_green">Crear nuevo usuario</h3>
                </div>
                <div
                    class="p-4 text-center border-2 cursor-pointer rounded-2xl border-light_green bg-light_yellow hover:bg-yellow"
                    @click="createClassification"
                >
                    <span class="material-symbols-outlined admin-icon text-light_gray">
                        space_dashboard
                    </span>
                    <h3 class="text-enriqueto_green">Crear nueva clasificación</h3>
                </div>
            </div>
            <hr class="mt-8 border-light_gray" />
            <div class="px-5">
                
            </div>
        </div>
        <ModalComponent
            :title="modalTitle + ' fruta'"
            v-model="fruitModal"
            v-if="fruitModal"
        >
            <FruitForm @added="resetModals" :fruit="fruitToCreate" />
        </ModalComponent>
        <ModalComponent
            :title="modalTitle + ' categoria'"
            v-model="categoryModal"
            v-if="categoryModal"
        >
            <CategoryForm @added="resetModals" :category="categoryToCreate" />
        </ModalComponent>
        <ModalComponent
            :title="modalTitle + ' un usuario'"
            v-model="userModal"
            v-if="userModal"
        >
            <UserForm @added="resetModals" :user="userToCreate" />
        </ModalComponent>
        <ModalComponent
            :title="modalTitle + ' clasificacion'"
            v-model="classificationModal"
            v-if="classificationModal"
        >
            <ClassificationForm @added="resetModals" :classification="classificationToCreate" :classifications="classifications" />
        </ModalComponent>
    </Layout>
</template>
